import React from 'react'
import { Link } from 'react-router-dom'
import { useMobileView } from '../../contexts/MobileViewContext'
import Pagecontainer from '../Pagecontainer'
import './styles/wave.css'

const Primaryservices = () => {

    const { mobileView } = useMobileView()

    return (
        <>
            <div className='flex flex-col items-center justify-center mt-20 mb-10'>
                <h3 className='text-primary font-sans text-2xl font-bold uppercase'>
                    Primary Services
                </h3>
                <div className='w-[30px] bg-primary h-[4px] my-2' />
            </div>
            {
                !mobileView ? (
                    <div className='flex flex-col md:flex-row md:items-start items-center justify-center gap-8 md:gap-12 px-5'>
                        <ServiceCard
                            title="Savings"
                            desc="Deposit money into your account and earn interest on it."
                            icon={require('../../assets/icons/savings.png')}
                        />
                        <ServiceCard
                            title="Loan"
                            desc="Get a loan from us in a fixed or variable interest rate."
                            icon={require('../../assets/icons/loan.png')}
                        />
                        <ServiceCard
                            title="Remittance"
                            desc="Send money to anyone in the world from any of our branches."
                            icon={require('../../assets/icons/remittance.png')}
                        />
                    </div>
                ) : (
                    <div className='grid grid-cols-1 px-5 gap-6'>
                        <MobileServiceCard
                            title="Savings"
                            desc="Deposit money into your account and earn interest on it."
                            icon={require('../../assets/icons/savings.png')}
                        />
                        <MobileServiceCard
                            title="Loan"
                            desc="Get a loan from us in a fixed or variable interest rate."
                            icon={require('../../assets/icons/loan.png')}
                        />
                        <MobileServiceCard
                            title="Remittance"
                            desc="Send money to anyone in the world from any of our branches."
                            icon={require('../../assets/icons/remittance.png')}
                        />
                    </div>
                )
            }
        </>
    )
}

const ServiceCard = (props) => {
    return (
        <Link
            to={`/services/${props.title.toLowerCase()}`}
            className="group block"
        >
            <div className="wave-card border relative overflow-hidden cursor-pointer">
                <div className='flex justify-center items-center mt-8 mb-4 z-20 relative'>
                    <div className='bg-white rounded-full p-4 border border-primary group-hover:shadow-xl transition-shadow duration-300'>
                        <img className='w-16 h-16 object-contain' src={props.icon} alt={props.title} />
                    </div>
                </div>
                <div className="wave-card-shape"></div>
                <div className="wave-card-shape"></div>
                <div className="wave-card-shape"></div>
                <div className='px-6 z-20 pb-6 flex flex-col justify-center items-center gap-3 relative'>
                    <h3 className="wave-card-title uppercase text-white text-2xl font-bold tracking-wide group-hover:scale-105 transition-transform duration-300">
                        {props.title}
                    </h3>
                    <p className="wave-card-subtitle text-sm text-center text-white text-opacity-90 leading-relaxed">
                        {props.desc}
                    </p>
                    <div className='mt-2 flex items-center gap-2 text-white text-opacity-80 group-hover:text-opacity-100 transition-opacity duration-300'>
                        <span className='text-sm font-medium'>Learn More</span>
                        <i className="bi bi-arrow-right-circle text-lg group-hover:translate-x-1 transition-transform duration-300"></i>
                    </div>
                </div>
            </div>
        </Link>
    )
}

const MobileServiceCard = (props) => {
    return (
        <Link
            to={`/services/${props.title.toLowerCase()}`}
            className="group block"
        >
            <div className='flex flex-col items-center justify-center p-8 bg-white border hover:shadow-xl transition-all duration-300 hover:border-primary hover:-translate-y-1'>
                <div className='bg-primary/10 rounded-full p-4 mb-4 group-hover:bg-primary/20 transition-colors duration-300'>
                    <img className='w-16 h-16 object-contain' src={props.icon} alt={props.title} />
                </div>
                <h2 className='uppercase text-primary font-bold my-2 text-xl group-hover:underline text-center'>
                    {props.title}
                </h2>
                <p className='text-base text-center text-gray-600 leading-relaxed mt-2'>
                    {props.desc}
                </p>
                <div className='mt-4 flex items-center gap-2 text-primary text-sm font-medium'>
                    <span>Explore</span>
                    <i className="bi bi-arrow-right-circle group-hover:translate-x-1 transition-transform duration-300"></i>
                </div>
            </div>
        </Link>
    )
}

export default Primaryservices